﻿cb.define(['common/common_VM.Extend.js'], function (common) {
  var ST_st_storein_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {

		var detailsModel = viewmodel.get("details");
    //向后台传递行号
      detailsModel.setState('orderField', 'rowno');
			detailsModel.on('rowColChange', function(args) {
        if (args.value.columnKey == 'batchno' || args.value.columnKey == 'define1' || args.value.columnKey == 'define2' || args.value.columnKey == 'define3' ||
        args.value.columnKey == 'define4' || args.value.columnKey == 'define5' || args.value.columnKey == 'define6' || args.value.columnKey == 'define7' ||
        args.value.columnKey == 'define8' || args.value.columnKey == 'define9' || args.value.columnKey == 'define10' || args.value.columnKey == 'define11' ||
        args.value.columnKey == 'define12' || args.value.columnKey == 'define13' || args.value.columnKey == 'define14' || args.value.columnKey == 'define15' ||
        args.value.columnKey == 'define16' || args.value.columnKey == 'define17' || args.value.columnKey == 'define18' || args.value.columnKey == 'define19' ||
        args.value.columnKey == 'define20' || args.value.columnKey == 'define21' || args.value.columnKey == 'define22' || args.value.columnKey == 'define23' ||
        args.value.columnKey == 'define24' || args.value.columnKey == 'define25' || args.value.columnKey == 'define26' || args.value.columnKey == 'define27' ||
        args.value.columnKey == 'define28' || args.value.columnKey == 'define29' || args.value.columnKey == 'define30') {
            return false;
         }
    });
    
    viewmodel.on('afterLoadData', function (args){
      var rows = detailsModel.getRows();
      var newRows = [];
      rows.forEach(function(item){
        //待入库数量
        if (item.qty>0)
           newRows.push(item);
      });
      detailsModel.setDataSource(newRows);
    });

      	//保存之前，校验出库仓库和入库仓库不可以相同
		viewmodel.on('beforeSave', function (args){
				var outWarehouse = viewmodel.get("outWarehouse").getValue();
				var inWarehouse = viewmodel.get("inWarehouse").getValue();
				if(outWarehouse == inWarehouse){
					cb.utils.alert("出库仓库和入库仓库不可以相同！");
					return false;
				}
      });


      let params = viewmodel.getParams();
      let mode = params && params.mode || env.VOUCHER_STATE_BROWSE;
      let gridModel = viewmodel.getGridModel();
      if (mode === "browse") {
        viewmodel.get("btnSave").setVisible(false);
        viewmodel.get("btnAbandon").setVisible(false);
      }
      if (mode === "add") {
        viewmodel.get("btnMoveprev").setVisible(false);
        viewmodel.get("btnMovenext").setVisible(false);
      }
    }
  }
  try {
    module.exports = ST_st_storein_VM_Extend;
  } catch (error) {

  }
  return ST_st_storein_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storein_VM.Extend.js